import { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import Plus from 'react-feather/dist/icons/plus.js'
import validate from './validate.js'
import Input from '../../Form/Field/Input.jsx'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Date from '../../Form/Field/Date.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import CardCol from "../../../../shared/components/Styled/Card/CardCol.jsx"
import CardRow from "../../../../shared/components/Styled/Card/CardRow.jsx"

import './CertificationForm.scss'
export const name = 'CertificationForm'

class CertificationForm extends Component {
  handleSubmit = (values) => {
    const subResult = this.props.handleSubmit(values)
    if (!subResult.then) {
      return subResult
    }
    return subResult
      .then((data) => {
        this.props.reset()
        return data
      })

  }

  render() {
    return (
      <div id={name} className="certification-form">
        <form autoComplete="off" onSubmit={this.handleSubmit}>
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
          <CardRow align="flex-end" gap="20px">
            <CardCol flex={1} className="formations-form-field-col">
              <Field
                label="Certification"
                name="label"
                type="text"
                maxLength={255}
                component={Input} />
            </CardCol>
            <CardCol flex={1}  className="formations-form-field-col">
              <Field
                label="Année d'obtention"
                name="date"
                type="text"
                dateFormat="YYYY"
                viewMode="years"
                initialViewMode="years"
                component={Date} />
            </CardCol>

            <CardCol>
              <button type="submit" className="mb-3 btn btn-outline-primary">
                <Plus/> Ajouter
              </button>
            </CardCol>
          </CardRow>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}></Loader>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(CertificationForm)
